module.exports = __webpack_public_path__ + "assets-cabinet/img/calendar-icon.ea407cb6.svg";